import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { useToggle } from '@openedx/paragon';

import messages from '@src/courseware/course/sidebar/sidebars/course-outline/messages';
import UnitLinkWrapper from '@src/courseware/course/sidebar/sidebars/course-outline/components/UnitLinkWrapper';

import UnitIcon, { UNIT_ICON_TYPES } from './UnitIcon';
import CompletionIcon from './generic/CompletionIcon';
import OutlineItemTitle from './generic/OutlineItemTitle';

const SidebarUnit = ({
  id,
  courseId,
  sequenceId,
  unit,
  isActive,
  isLocked,
  activeUnitId,
}) => {
  const intl = useIntl();
  const {
    complete,
    title,
    icon = UNIT_ICON_TYPES.other,
  } = unit;

  const [unitIconVisible, setVisible, setHidden] = useToggle(false);

  const iconType = isLocked ? UNIT_ICON_TYPES.lock : icon;

  return (
    <UnitLinkWrapper
      {...{
        sequenceId,
        activeUnitId,
        id,
        courseId,
      }}
    >
      <div
        className={`title-wrapper outline-item-hover ${isActive && 'isActive'}`}
        onMouseEnter={setVisible}
        onMouseLeave={setHidden}
      >
        <OutlineItemTitle
          icon={(<CompletionIcon completionStat={{ total: 1, completed: complete ? 1 : 0 }} />)}
          title={title}
          screenreaderMessage={intl.formatMessage(complete ? messages.completedUnit : messages.incompleteUnit)}
        />
        {unitIconVisible && (
          <div className="outline-item-icon ml-n1">
            <UnitIcon {...{ type: iconType }} />
          </div>
        )}
      </div>
    </UnitLinkWrapper>
  );
};

SidebarUnit.propTypes = {
  id: PropTypes.string.isRequired,
  unit: PropTypes.shape({
    complete: PropTypes.bool,
    icon: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  isActive: PropTypes.bool.isRequired,
  isLocked: PropTypes.bool.isRequired,
  courseId: PropTypes.string.isRequired,
  sequenceId: PropTypes.string.isRequired,
  activeUnitId: PropTypes.string.isRequired,
};

export default SidebarUnit;
